<template>
  <div class="app-horizontal-layout">
    <template v-if="!session_ready">
      <preloader></preloader>
    </template>
    <template v-else>
      <public-invitation :hash="hash" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Preloader from '@/components/Common/Preloader'
import PublicInvitation from '@/components/Auth/PublicInvitation'

export default {
  name: 'InvitationView',
  components: {
    Preloader,
    PublicInvitation
  },
  props: {
    hash: {
      type: String,
      required: true
    }
  },
  computed: mapGetters(['session_ready'])
}
</script>

<style scoped>
  .app-horizontal-layout {
    height: 100vh;
  }
</style>
